import _get from "lodash/get"
import React from "react"

import AccessControl from "./src/components/access/AccessControl"
import RedirectExternalSite from "./src/components/access/RedirectExternalSite"
import ErrorBoundary from "./src/components/ErrorBoundary"
import { ENV } from "./src/constants/env"
import EventPage from "./src/pages/events/[slug]"
import { getCookieByName } from "./src/utils/cookies"

// This will catch and display runtime errors in production
if (process.env.NODE_ENV === "production") {
  // Add global error handler for unhandled errors
  if (typeof window !== "undefined") {
    window.onerror = (message, source, line, column, error) => {
      // Create an error display element
      const errorDiv = document.createElement("div");
      errorDiv.style.margin = "20px";
      errorDiv.style.padding = "20px";
      errorDiv.style.border = "1px solid #f55";
      errorDiv.style.borderRadius = "4px";
      errorDiv.style.backgroundColor = "#fee";
      
      // Add error details
      errorDiv.innerHTML = `
        <h2>Runtime Error Caught</h2>
        <p><strong>Message:</strong> ${message}</p>
        <p><strong>Source:</strong> ${source}</p>
        <p><strong>Line:</strong> ${line}, <strong>Column:</strong> ${column}</p>
        <pre>${error?.stack || "No stack trace available"}</pre>
      `;
      
      // Append to body or a container element
      document.body && document.body.appendChild(errorDiv);
      
      // Also log to console for Netlify logs
      console.error("UNHANDLED ERROR:", message, source, line, column, error);
      
      // Send to monitoring service if available
      // if (window.yourMonitoringService) window.yourMonitoringService.captureException(error);
      
      return true; // Prevents default error handling
    };

    // Add promise rejection handler
    window.onunhandledrejection = (event) => {
      console.error("Unhandled Promise Rejection:", event.reason);
      
      const errorDiv = document.createElement("div");
      errorDiv.style.margin = "20px";
      errorDiv.style.padding = "20px";
      errorDiv.style.border = "1px solid #f55";
      errorDiv.style.borderRadius = "4px";
      errorDiv.style.backgroundColor = "#fee";
      
      errorDiv.innerHTML = `
        <h2>Unhandled Promise Rejection</h2>
        <pre>${event.reason?.stack || event.reason?.message || JSON.stringify(event.reason)}</pre>
      `;
      
      document.body && document.body.appendChild(errorDiv);
    };
  }
}

export const wrapPageElement = ({ element, props }) => {
  const isWindowDefined = typeof window !== "undefined"
  const storedPassword = getCookieByName("ttf-access")
  const elementType = _get(element, "type.name")
  
  // Start by wrapping everything in ErrorBoundary
  let wrappedElement = <ErrorBoundary>{element}</ErrorBoundary>

  if (elementType === EventPage.name) {
    const externalUrl = _get(props, "serverData.event.event.redirect_url")
    if (externalUrl) {
      return <ErrorBoundary><RedirectExternalSite externalUrl={externalUrl} /></ErrorBoundary>
    }
  }

  if (storedPassword === ENV.TTF_ACCESS) {
    return wrappedElement
  }

  if (isWindowDefined && window.location.hostname === "tickets-staging.manacommon.com") {
    return <ErrorBoundary><AccessControl /></ErrorBoundary>
  }
  
  return wrappedElement
}
